import React, { useState } from 'react'
import cx from 'classnames'
import { connect } from 'react-redux'
import { Input } from 'reactstrap'
import { setIsLoading } from '../../reduxSetup/action'
import validateEmail from '../../services/validateEmail'
import Button from '../../components/Button/Button'
import FormItemWithValidation from '../../components/FormItemWithValidation/FormItemWithValidation'
import { signup, login } from '../../services/api'
import { setUser } from '../../reduxSetup/action'
import PropTypes from 'prop-types'

import styles from './Login.module.scss'

const Login = ({ setIsLoading, setToken, setUser }) => {
	const [isSignup, setIsSignup] = useState(false)
	const [firstName, setFirstName] = useState(false)
	const [secondName, setSecondName] = useState(false)
	const [email, setEmail] = useState(false)
	const [password, setPassword] = useState(false)
	const [passwordConformation, setPasswordConformation] = useState(false)
	const [validationError, setValidationError] = useState([])

	const handleFieldChange = (value, setStateFunction, filterType) => {
		// eslint-disable-next-line default-case
		setStateFunction(value)
		value.length &&
			setValidationError(
				validationError.filter((errorItem) => errorItem !== filterType)
			)
	}

	const handleSubmit = () => {
		; (!email || !validateEmail(email)) &&
			setValidationError((prevValidationError) => [
				...prevValidationError,
				'email'
			])
		!password &&
			setValidationError((prevValidationError) => [
				...prevValidationError,
				'password'
			])

		if (isSignup) {
			!firstName &&
				setValidationError((prevValidationError) => [
					...prevValidationError,
					'firstName'
				])
			!secondName &&
				setValidationError((prevValidationError) => [
					...prevValidationError,
					'secondName'
				])
				; (!passwordConformation || passwordConformation !== password) &&
					setValidationError((prevValidationError) => [
						...prevValidationError,
						'passwordConformation'
					])
		}
		if (
			isSignup &&
			firstName &&
			secondName &&
			email &&
			validateEmail(email) &&
			password &&
			passwordConformation &&
			passwordConformation === password
		) {
			setIsLoading(true)
			signup({ firstName, secondName, email, password, isAdmin: true })
				.then((response) => {
					if (!response || !response.data) {
						alert(`The user already exists. Please, login.`)
						return
					}
					// response?.data?.token && setToken(response.data.token)
					response?.data?.user && setUser({user:response.data.user, token: response.data.token})
				})
				.finally(() => {
					setIsLoading(false)
				})
		}
		if (!isSignup && email && validateEmail(email) && password) {
			setIsLoading(true)
			login({ email, password, isAdmin: true })
				.then((response) => {
					if (!response || !response.data) {
						alert(`Email or password is not correct.`)
						return
					}
					// response?.data?.token && setToken(response.data.token)
					response?.data?.user && setUser({ user: response.data.user, token: response.data.token })
				})
				.finally(() => {
					setIsLoading(false)
				})
		}
	}

	return (
		<div className={styles.container}>
			<div>
				<h2 className={styles.title}>
					{!isSignup ? 'Log in' : 'Sign up'}
				</h2>
				{isSignup && (
					<>
						<FormItemWithValidation
							validationError={validationError}
							itemName='firstName'
						>
							<Input
								className={cx(styles.input, {
									[styles.inputError]:
										validationError.includes('firstName')
								})}
								placeholder='Write first name'
								onChange={(e) => {
									handleFieldChange(
										e.target.value,
										setFirstName,
										'firstName'
									)
								}}
							/>
						</FormItemWithValidation>
						<FormItemWithValidation
							validationError={validationError}
							itemName='secondName'
						>
							<Input
								className={cx(styles.input, {
									[styles.inputError]:
										validationError.includes('secondName')
								})}
								placeholder='Write second name'
								onChange={(e) => {
									handleFieldChange(
										e.target.value,
										setSecondName,
										'secondName'
									)
								}}
							/>
						</FormItemWithValidation>
					</>
				)}
				<FormItemWithValidation
					validationError={validationError}
					itemName='email'
				>
					<Input
						className={cx(styles.input, {
							[styles.inputError]:
								validationError.includes('email')
						})}
						placeholder='Write email'
						onChange={(e) => {
							handleFieldChange(e.target.value, setEmail, 'email')
						}}
						name='email'
					/>
				</FormItemWithValidation>
				<FormItemWithValidation
					validationError={validationError}
					itemName='password'
				>
					<Input
						className={cx(styles.input, {
							[styles.inputError]:
								validationError.includes('password')
						})}
						placeholder='Write password'
						onChange={(e) => {
							handleFieldChange(
								e.target.value,
								setPassword,
								'password'
							)
						}}
						name='password'
					/>
				</FormItemWithValidation>
				{isSignup && (
					<FormItemWithValidation
						validationError={validationError}
						itemName='passwordConformation'
					>
						<Input
							className={cx(styles.input, {
								[styles.inputError]: validationError.includes(
									'passwordConformation'
								)
							})}
							placeholder='Write password'
							onChange={(e) => {
								handleFieldChange(
									e.target.value,
									setPasswordConformation,
									'passwordConformation'
								)
							}}
						/>
					</FormItemWithValidation>
				)}
				<Button className={styles.submit} onClick={handleSubmit}>
					{isSignup ? 'Sign up' : 'Log in'}
				</Button>
			</div>
			<div className={styles.footer}>
				{!isSignup && <p>Don't have an accout yet? </p>}
				<Button
					className={styles.toggleButton}
					onClick={() => setIsSignup(isSignup ? false : true)}
				>
					{isSignup ? ' Log in' : 'Sign up'}
				</Button>
			</div>
		</div>
	)
}

Login.propTypes = {
	setIsLoading: PropTypes.func,
	// setToken: PropTypes.func,
	setUser: PropTypes.func
}
Login.dafaultProps = {
	setIsLoading: () => { },
	// setToken: () => {},
	setUser: () => { }
}

const mapDispatchToProps = {
	setIsLoading,
	setUser
}

export default connect(null, mapDispatchToProps)(Login)
